/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Edit_Mode_StatusInputs */

const en_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Mode Status`)
};

const fr_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut du mode edition`)
};

const de_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeitungsmodus-Status`)
};

const it_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato della modalità di modifica`)
};

const ru_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус режима редактирования`)
};

const es_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado del modo de edición`)
};

const zh_cn2_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑模式状态`)
};

const ja_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集モードのステータス`)
};

const hi_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादन मोड स्थिति`)
};

const pt_pt2_editor_edit_mode_status = /** @type {(inputs: Editor_Edit_Mode_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status do Modo de Edição`)
};

/**
* | output |
* | --- |
* | "Edit Mode Status" |
*
* @param {Editor_Edit_Mode_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_edit_mode_status = /** @type {((inputs?: Editor_Edit_Mode_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Edit_Mode_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_edit_mode_status(inputs)
	if (locale === "de") return de_editor_edit_mode_status(inputs)
	if (locale === "it") return it_editor_edit_mode_status(inputs)
	if (locale === "ru") return ru_editor_edit_mode_status(inputs)
	if (locale === "es") return es_editor_edit_mode_status(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_edit_mode_status(inputs)
	if (locale === "ja") return ja_editor_edit_mode_status(inputs)
	if (locale === "hi") return hi_editor_edit_mode_status(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_edit_mode_status(inputs)
	return en_editor_edit_mode_status(inputs)
});